var exports = {
  "$P": "StreamSettingsMenuContent.module__modeItem___WHQ2LW",
  "Q6": "StreamSettingsMenuContent.module__modeLabelColumn___WHQ2LW",
  "i2": "StreamSettingsMenuContent.module__modeTitle___WHQ2LW",
  "ED": "StreamSettingsMenuContent.module__modeDescription___WHQ2LW",
  "nM": "StreamSettingsMenuContent.module__row___WHQ2LW",
  "xZ": "StreamSettingsMenuContent.module__rowLabel___WHQ2LW",
  "BE": "StreamSettingsMenuContent.module__premiumBadge___WHQ2LW",
  "JV": "StreamSettingsMenuContent.module__audioDeviceLabel___WHQ2LW",
  "ue": "StreamSettingsMenuContent.module__audioDeviceName___WHQ2LW",
  "Ky": "StreamSettingsMenuContent.module__audioDeviceSubtext___WHQ2LW",
  "HA": "StreamSettingsMenuContent.module__compactLiveGroupLabel___WHQ2LW",
  "Au": "StreamSettingsMenuContent.module__audioDeviceIcon___WHQ2LW",
};

module.exports = exports;
